function registerInfiniteScrollLoadMoreButton() {
    const selectors = {
      loadMoreButton: ".js-load-more",
      totalPages: "[data-total-pages]",
      currentPage: "[data-current-page]",
      nextUrl: "[data-next-url]",
      loadMoreText: "[load-more-text]",
      loaderText: "[loader-text]",
      products:
        ".collection__products .grid-item.product-item:not(.product-grid-item-placeholder):not(.desktop-breaker):not(.mobile-breaker)",
      productGrid: "div[data-products-grid] .grid",
      currentProducts: ".current-products",
      totalProducts: ".total-products",
    };

    const hideClass = "hide";

    // Delegated listener: the button and its hidden inputs live inside
    // [data-products-grid], which sorting/filtering replaces via innerHTML.
    document.addEventListener("click", (e) => {
      const loadMoreButton = e.target.closest(selectors.loadMoreButton);
      if (!loadMoreButton) return;

      const totalPages = document.querySelector(selectors.totalPages);
      const currentPage = document.querySelector(selectors.currentPage);
      const nextUrl = document.querySelector(selectors.nextUrl);
      const currentProducts = document.querySelector(selectors.currentProducts);
      const totalProducts = document.querySelector(selectors.totalProducts);

      if (!totalPages || !currentPage || !nextUrl) return;

      const totalPagesValue = Number(totalPages.value);
      const currentPageValue = parseInt(currentPage.value);

      loadMoreButton.setAttribute("disabled", true);

      const loadMoreText = loadMoreButton.querySelector(selectors.loadMoreText);
      const loaderText = loadMoreButton.querySelector(selectors.loaderText);

      loadMoreText.classList.add(hideClass);
      loaderText.classList.remove(hideClass);

      fetch(nextUrl.value)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const products = doc.querySelectorAll(selectors.products);
          insertProducts(products);

          const newUrl = nextUrl.value;

          nextUrl.value = nextUrl.value.replace(
            `page=${currentPageValue + 1}`,
            `page=${currentPageValue + 2}`
          );
          currentPage.value = currentPageValue + 1;

          if (currentPage.value >= totalPagesValue) {
            loadMoreButton.classList.add(hideClass);

            if (currentProducts && totalProducts) {
              currentProducts.innerHTML = totalProducts.innerHTML;
            }
          }

          loadMoreButton.removeAttribute("disabled");
          loadMoreText.classList.remove(hideClass);
          loaderText.classList.add(hideClass);

          window.history.pushState(
            {
              param: Shopify.queryParams,
            },
            document.title,
            newUrl
          );
        })
        .catch((error) => {
          console.warn("Loading more products failed", error);
          loadMoreButton.classList.add(hideClass);
        });
    });
  }

function insertProducts(products, before = false) {
  const selectors = {
    productGrid: "div[data-products-grid] .grid",
    currentProducts: ".current-products",
    productCard: ".grid-item.product-item:not(.product-grid-item-placeholder):not(.desktop-breaker):not(.mobile-breaker)",
  };

  const productGrid = document.querySelector(selectors.productGrid);

  products.forEach((product) => {
    if (before) {
      productGrid.prepend(product);
    } else {
      productGrid.appendChild(product);
    }
  });

  const currentProducts = document.querySelector(selectors.currentProducts);
  currentProducts.innerHTML = productGrid.querySelectorAll(selectors.productCard).length;

  // Re-initialize flickity dots for newly loaded products
  if (typeof window.initProductGridDots === 'function') {
    setTimeout(() => {
      window.initProductGridDots();
    }, 100);
  }
}

registerInfiniteScrollLoadMoreButton();

async function addPreviousCollectionProducts() {
  const selectors = {
    productGrid: "div[data-products-grid] .grid",
    products: "div[data-products-grid] .grid .grid-item.product-item:not(.product-grid-item-placeholder)",
  };

  const previousProductDivs = document.querySelectorAll(".js-collection-previous-products");
  const reversedPreviousProductDivs = Array.from(previousProductDivs);
  const previousProducts = [];

  const promises = reversedPreviousProductDivs.map((div) => {
    const url = div.getAttribute("data-url");
    return fetch(url).then((response) => response.text());
  });

  const responses = await Promise.all(promises);

  responses.forEach((html, index) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const products = doc.querySelectorAll(selectors.products);
    previousProducts.push(...products);
  });

  const productGrid = document.querySelector(selectors.productGrid);
  const placeholders = [...document.querySelectorAll(".product-grid-item-placeholder")];

  previousProducts.forEach((product, index) => {
    if (placeholders[index]) {
      placeholders[index].outerHTML = product.outerHTML;
    } else {
      productGrid.prepend(product);
    }
  });

  placeholders.slice(previousProducts.length).forEach((placeholder) => placeholder.remove());
}

(async function () {
  await addPreviousCollectionProducts();
})();